import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { setActiveModuleR } from "../../../../General/Store/GeneralSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

function ModuleMenu({ open ,toggleMenuHandler }) {
  const  theme =useTheme().palette.mode
  const dispatach = useDispatch();
  const activeModule = useSelector((state) => state.general.activeModule);

  const [moduleList, setModuleList] = useState([]);

  const submenuChecker = (permisions) => {
    //subMenu item Clamies
    const productionClamies = [
      "Order",
      "LaserLayoutFilmProduction",
      "DesigningDepartment",
      "OrderRipDepartment",
      "KlischeAssemblyDepartment",
      "OrderPackagingDepartment",
      "PreProductionDepartment",
      "FinancialDepartment",
      "ProductionQCDepartment",
      "OrderSendingDepartment",
      "OrderArchive",
      "FormAfzar",
      "Plate",
      "OrderCuttingDepartment",
    ];
    const baseInfoClamies = [
      "OrganizationUnit",
      "Role",
      "Chart",
      "Person",
      "User",
      "Post",
      "PersonGroup",
      "PersonContract",
      "BankInfo",
      "InsuranceJob",
      "InsuranceType",
      "EnumOption",
    ];
    const productionInfoClamies = [
      "KlischeType",
      "KlischeTypeAndThickness",
      "KlischeThickness",
      "KlischePrice",
      "ProductionDevice",
      "TramType",
      "processStep",
      "Lpi",
      "Dpi",
      "DesignerQCTypes",
      "GroupCausesDamage",
      "QualityControlTypes",
    ];
    const WarehouseClaim = [
      "ProductionWarehouse",
      "MaterialRequest",
      "PartialMaterial",
    ];
    const ReportsClaim = [
      "Report",
      "ReportFilter",
      "ReportChart",
      "ReportList",
    ];

    const letterClaim = ["ChangePriceLetter"];

    const orderPaymentClaim = ["OrderPayment"];

    const customerCliam =["OrderOnline"]
    //* INFO check if has Clamies item subMen display
    const production = permisions?.some((permision) =>
      productionClamies?.includes(permision.controllerName)
    );
    const baseInfo = permisions?.some((permision) =>
      baseInfoClamies?.includes(permision.controllerName)
    );

    const productionInfo = permisions?.some((permision) =>
      productionInfoClamies?.includes(permision.controllerName)
    );
    // انبار
    const warehouse = permisions?.some((permision) =>
      WarehouseClaim?.includes(permision.controllerName)
    );
    //گزارشات
    const report = permisions?.some((permision) =>
      ReportsClaim?.includes(permision.controllerName)
    );
    //نامه ها
    const letters = permisions?.some((permision) =>
      letterClaim?.includes(permision.controllerName)
    );
    //سند واریزی
    const orderPayment = permisions?.some((permision) =>
      orderPaymentClaim.includes(permision.controllerName)
    );
    // مشتری
    const customer =permisions?.some((permision) =>
      customerCliam.includes(permision.controllerName)
    );
    //* INFO SubMenu state Flag
    setModuleList([
      {
        id: "production",
        title: "تولید",
        display: production,
        icon: "",
      },
      {
        id: "werhouse",
        title: "انبار",
        display: warehouse,
        icon: "",
      },
      {
        id: "letter",
        title: "نامه نگاری",
        display: letters,
        icon: "",
      },
      {
        id: "baseInfo",
        title: "اطلاعت پایه",
        display: baseInfo,
        icon: "",
      },
      {
        id: "report",
        title: "گزارشات",
        display: report,
        icon: "",
      },
      {
        id: "orderPayment",
        title: "سند واریزی",
        display: orderPayment,
        icon: "",
      },
      {
        id: "customer",
        title: "مشتریان",
        display: customer,
        icon: "",
      },
      {
        id: "productionInfo",
        title: "اطلاعات پایه تولید",
        display: productionInfo,
        icon: "",
      },
      {
        id: "damage",
        title: "خرابی",
        display: true,
        icon: "",
      },
      {
        id: "communication",
        title: "ارتباط با مشتری",
        display: true,
        icon: "",
      },
    ]);
  };

  const moduleClickHandler = (id) => {
    toggleMenuHandler(false);
    dispatach(setActiveModuleR(id));
  };

  useEffect(() => {
    let permisions = JSON.parse(localStorage.getItem("claims"));
    submenuChecker(permisions);
  }, []);
  useEffect(() => {

  }, [activeModule]);

  if (open) {
    return (
      <Box className={`module-menu ${theme==="dark"?"dark" :"light"}`} >
        <ul
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            listStyle: "none",
          }}
        >
          {moduleList
            ?.filter((item) => item.display === true)
            .map((menu) => (
              <li style={{ width: "30%" ,margin:"4px 0px"}} key={menu.id}>
                <Button
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding:"0.5rem ",
                    boxShadow:
                      activeModule === menu.id
                        ? "0px 2px 6px 2px #00000026"
                        : "",
                  }}
                  onClick={() => moduleClickHandler(menu.id)}
                >
                  <Box
                    sx={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 4px 0px #5856D63D",
                    }}
                  ></Box>

                  <Typography fontSize={"12px"} color={theme==="dark" ?   "#FFFFFF":"black"}>{menu.title} </Typography>
                </Button>
              </li>
            ))}
        </ul>
      </Box>
    );
  }
}

export default ModuleMenu;
